
if (!theme.Shopify) theme.Shopify = {};
try {
  theme.Shopify.features = JSON.parse(document.documentElement.querySelector('#shopify-features').textContent);
} catch (e) {
  theme.Shopify.features = {};
}

function getSparXpressData(variantPrice){
  console.log('Get xPress data');
  const sparXpressElement = document.getElementById('sparxpres-product');
  if(sparXpressElement){
    console.log('New xpres price: ', variantPrice);
    sparXpressElement.setAttribute('data-price', variantPrice);
  }

  (function(d,l){var f=d.getElementsByTagName('script')[0],s=d.createElement('script');s.async=true;s.src='https://sparxpres.dk/app/webintegration/static/module-loader.js';s.onload=function(){sparxpresClientLoader(l);};f.parentNode.insertBefore(s,f);})(document,'995e1510-647f-414f-9e50-e8168322b715');
}